import type { ReactNode } from 'react';

import { ToastCheckmarkIcon } from '@/ui/Icons/ToastCheckmarkIcon';
import { ToastCrossIcon } from '@/ui/Icons/ToastCrossIcon';

import { classNames } from '@/utils/classnames';

import styles from './FeedbackAnimation.module.css';

interface FeedbackAnimationProps {
  feedback?: 'success' | 'error';
  children?: ReactNode;
  className?: string;
}

export const FeedbackAnimation = ({ feedback, children, className }: FeedbackAnimationProps) => {
  const isSuccess = feedback === 'success';
  const isError = feedback === 'error';

  return (
    <div className={classNames('relative size-10', className)}>
      <div
        className={classNames(
          styles.content,
          feedback != null ? styles.contentWithFeedback : undefined,
        )}
      >
        {children}
      </div>

      {isSuccess && <div className={styles.radial} aria-hidden="true" />}

      {feedback != null && (
        <div
          className={classNames(
            'absolute flex items-center justify-center size-7 m-1.5 p-1.5 top-0 right-0',
            'shadow-15 rounded-full text-primitive-basic-white',
            { [`bg-token-green-900 ${styles.successIcon}`]: isSuccess },
            { [`bg-token-red-900 ${styles.errorIcon}`]: isError },
          )}
        >
          {isSuccess && <ToastCheckmarkIcon className="relative z-10 size-7" />}
          {isError && <ToastCrossIcon className="relative z-10 size-7" />}
        </div>
      )}
    </div>
  );
};
